
import {
  minLength,
  required,
  email
} from "vuelidate/lib/validators";
import errorParseNetwork from "~/helpers/errorParseNetwork";

export default {
  name: "SectionForm",

  data: function () {
    return {
      formItem: {
        name: "",
        phone: "",
        email: ""
      },
    }
  },

  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    section: {
      type: Object,
      default: () => {
        return {}
      }
    },
    indexForm: {
      type: Number,
      default: 0
    }
  },

  computed: {
    errorName: function () {
      const error = this.$v?.formItem?.name;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorEmail: function () {
      const error = this.$v?.formItem?.email;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.email) {
        return "Неправильный формат ввода"
      }

      return null
    },
    errorPhone: function () {
      const error = this.$v?.formItem?.phone;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Неправильный формат ввода"
      }

      return null
    },
  },

  validations: function () {
    const formItem = {
      name: {
        required
      },
      phone: {
        required,
        minLength: minLength(18)
      },
      email: {
        email
      },
    };

    return {
      formItem,
    };
  },

  methods: {
    submitForm: async function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      this.$emit("submitForm", this.formItem)
    }
  }

}
